import React from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useTheme } from '@mui/material/styles';

const DeleteButton = ({ style, className, ...props }) => {
	const theme = useTheme();
	const useStyles = makeStyles(() => ({
		root: {
			justifyContent: 'center',
			padding: '0',
		},
		button: {
			border: `1px solid ${theme.palette.error.main}`,
			borderStyle: 'solid',
			borderWidth: '1px',
			backgroundColor: 'white',
			color: theme.palette.error.main,
			marginLeft: '8px',
			fontSize: '12px',
			padding: '8px 16px',
			letterSpacing: '0.08em',
			borderRadius: '24px',
			boxSizing: 'border-box',
			'&:hover': {
				backgrounColor: theme.palette.error.main,
				cColor: 'white',
				fontWeight: 'bold',
			},
			[theme.breakpoints.down('md')]: {
				fontSize: '12px',
			},
			...style,
		},
	}));

	const classes = useStyles();

	return (
		<React.Fragment>
			<Button
				variant='contained'
				className={clsx(classes.button, className ? className : null)}
				onClick={props.onClick}
				{...props}>
				{props.children}
			</Button>
		</React.Fragment>
	);
};

export default DeleteButton;
